document.addEventListener('DOMContentLoaded', () => {
  function initDeliveryInfoBarSwipers() {
    const viewportWidth = window.innerWidth;
    const swiperElements = document.querySelectorAll('.delivery-info-bar-swiper');

    swiperElements.forEach(swiperElement => {
      if (viewportWidth < 1025) {
        if (!swiperElement.swiper && window.Swiper) {
          new Swiper(swiperElement, {
            speed: 400,
            spaceBetween: 20,
            slidesPerView: 1,
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false
            },
            pagination: {
              el: swiperElement.querySelector('.swiper-pagination'),
              clickable: true
            }
          });
        }
      } else if (swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
      }
    });
  }

  initDeliveryInfoBarSwipers();
  window.addEventListener('resize', initDeliveryInfoBarSwipers);
});
